module.exports = __webpack_public_path__ + "img/q15.f9dae08e.jpeg";